import React from 'react';
import ReactTable from 'react-table';
import styled from 'styled-components';
import { grey, gridError, yellow } from 'styles/Colors';

export const StyledReactTable = styled((props) => <ReactTable {...props} />)`
  &&& {
    box-shadow: none !important;
    .rt-table {
      min-height: 336px;
      z-index: 1;

      .rt-thead {
        padding: 0 15px;
      }

      .rt-tr-group {
        max-height: 48px;
        padding: 0 15px;

        &:hover {
          cursor: pointer;
          background-color: #f5f5f5;
        }
      }

      .rt-tr {
        height: 48px;
        line-height: 30px;
        overflow: hidden;

        .rt-td,
        .rt-th {
          line-height: 28px;
          padding: 0 !important;
          font-size: 13px;
          text-align: left;
          display: flex;
          align-items: center;
          border-right: none;
        }

        .rt-th {
          font-weight: 700;
        }
      }
    }
    .name-cell {
      .name-checkbox {
        .checkbox {
          margin-top: 3px;
        }
        .label {
          line-height: 28px;
        }
      }
      &.discrepant {
        border-color: ${yellow};
        width: 100%;
        padding-left: 0;
        padding-right: 0;
        margin: none;
      }
    }
    .discrepant {
      height: 100%;
      box-sizing: border-box;
      border: 2px solid ${gridError};
      border-radius: 4px;
      width: fit-content;
      padding-left: 4px;
      padding-right: 4px;
      margin: 0 auto;
    }
    .rt-noData {
      background: transparent;
    }
  }
`;

export const PlayerContent = styled.div`
  line-height: 17px;
`;

export const PlayerTeam = styled.div`
  font-size: 11px;
  color: ${grey};
`;

export const ClickableCell = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
`;
